#import "../fragments/domain-fragment.graphql"

mutation DeleteSubdomain($subdomain: SubdomainDeleteInput!) {
    subdomainDelete(input: $subdomain) {
        fullDomain {
            ...DomainFragment
        }
    }
}
